module.exports = __webpack_public_path__ + "static/media/time-icon.e594bb21.svg";